import CTLUnReadCell from "application/components/CTLUnReadCell";


const operationURLS = {
  list: "queuePerformance/list",
  pdfDownload: "/queuePerformance/generateAndDownloadPdf",
  csvDownload: "/queuePerformance/downloadCSV",
  filterCSV: "queuePerformance/downloadCSV1",
};

const getColumns = () => {
  return [
    {
      Header: "Queue Id",
      accessor: "queue",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      allowReportFilter: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
      controlType: "multipleSelect",
      filterControlType: "select",
      allowReportColumn: true,
      options: {
        keyField: "queue",
        keyDescription: "queueName",
        values: [],
        url: "queuePerformance/queue",
      },
    },
    {
      Header: "Queue Name",
      accessor: "queueName",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Avg No",
      accessor: "averageNumberAgent",
      downloadReports: true,
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Call Direction",
      accessor: "callDirection",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Record DateTime",
      accessor: "recordEpoch",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "date",
      allowReportColumn: true,
      allowReportFilter: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Call Offered",
      accessor: "totalJoined",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Call Answered",
      accessor: "totalConnectedWithAgent",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    // {
    //   Header: "Total No Answered",
    //   accessor: "totalNoContact",
    //   displayInList: true,
    //   allowInForm: true,
    //   allowFilter: false,
    //   dataType: "integer",
    //   allowReportColumn: true,
    //   Cell: ({ value }) => <CTLUnReadCell value={value} />,
    // },
    {
      Header: "ABD At Agent",
      accessor: "totalAbandonedAtAgent",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ABD At ACD",
      accessor: "totalAbandonedAtQueue",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
         Header: "Total Dial Out",
         accessor: "totalDialedOut",
         displayInList: true,
         allowInForm: false,
         allowFilter: false,
         dataType: "integer",
         allowReportColumn: true,
         Cell: ({ value }) => <CTLUnReadCell value={value} />,
       },
       {
         Header: "Contacted",
         accessor: "totalDialedOutConnected",
         displayInList: true,
         allowInForm: false,
         allowFilter: false,
         dataType: "integer",
         allowReportColumn: true,
         Cell: ({ value }) => <CTLUnReadCell value={value} />,
       },
       {
         Header: "Not Contacted",
         accessor: "totalDialedOutNotConnected",
         displayInList: true,
         allowInForm: false,
         allowFilter: false,
         allowReportColumn: true,
         dataType: "integer",
         Cell: ({ value }) => <CTLUnReadCell value={value} />,
       },
    {
      Header: "Total Talk Time",
      accessor: "totalCustomerAgentTalkTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Avg Talk Time",
      accessor: "averageTalkTime",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Wait Time",
      accessor: "totalWaitTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Avg Ans Wait Time",
      accessor: "averageAnswerWaitTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Ans Wait 10 Second",
      accessor: "answerWaitSecond10",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Ans Wait 20 Second",
      accessor: "answerWaitSecond20",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Ans Wait 30 Second",
      accessor: "answerWaitSecond30",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Ans Wait 40 Second",
      accessor: "answerWaitSecond40",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Ans Wait 50 Second",
      accessor: "answerWaitSecond50",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Ans Wait 60 Second",
      accessor: "answerWaitSecond60",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Ans Wait >60 Second",
      accessor: "greaterAnswerWaitSecond60",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total ABD Wait Time",
      accessor: "totalAbandonedWaitTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Avg ABD Wait Time",
      accessor: "averageAbandonedWaitTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ABD Wait 10 Second",
      accessor: "abandonedWaitSecond10",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ABD Wait 20 Second",
      accessor: "abandonedWaitSecond20",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ABD Wait 30 Second",
      accessor: "abandonedWaitSecond30",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ABD Wait 40 Second",
      accessor: "abandonedWaitSecond40",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ABD Wait 50 Second",
      accessor: "abandonedWaitSecond50",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ABD Wait 60 Second",
      accessor: "abandonedWaitSecond60",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ABD Wait >60 Second",
      accessor: "greaterAbandonedWaitSecond60",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: "Service %",
      accessor: "servicePercentage",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Abandoned %",
      accessor: "abandonedPercentage",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
  ];
};

export { getColumns, operationURLS };
